<div class="d-flex flex-column gap-2">
  <div class="d-flex gap-2 align-items-start pb-2">
    <div class="name-and-pill text-start">
      <div class="title-sm">
        <span *ngIf="account?.governingJurisdictionId">{{ account?.governingJurisdiction?.name }} </span>
        <span i18n *ngIf="!account?.governingJurisdictionId">Non-Locked-In </span>
        {{ account?.type.name }}
      </div>
      <div class="d-flex gap-2 align-items-center">
        <app-ip-account-status-menu
          *ngIf="showStatusMenu; else statusPill"
          [account]="account"
          [allowStrike]="true"
          (statusSelected)="statusSelected.emit($event)" />
        <ng-template #statusPill>
          <app-status-pill [statusPill]="account.status | accountStatusPill" />
        </ng-template>
        <app-status-pill *ngIf="isSpousal" [statusPill]="spousalPill" />
      </div>
    </div>
    <app-text-button
      [type]="ButtonTypeEnum.accent"
      [disabled]="viewAccountDisabled"
      (buttonClicked)="viewAccountClicked.emit()">
      <div class="d-flex align-items-center gap-2">
        <span i18n>View Account</span>
        <div>
          <img
            src="assets/icons/primary/Chevron%20Right.svg"
            alt=""
            [style.height.rem]="1.125"
            [style.width.rem]="1.125" />
        </div>
      </div>
    </app-text-button>
  </div>
  <div class="d-flex gap-2 align-items-start justify-content-between details">
    <div class="d-flex flex-column gap-2 text-start">
      <ng-container *ngIf="holderName; else ownAccount">
        <span class="account-holder">{{ holderName }} ({{ holderMemberId | leadingZero : 8 }})</span>
      </ng-container>
      <ng-template #ownAccount>
        <span *ngIf="account.spousalRolloverAccount" class="spousal-rollover" i18n>Spousal VB Created</span>
        <span *ngIf="account.spousalRolloverSource as source" class="account-holder" i18n
          >Continuation from {{ source.sourceMemberName }} ({{ source.sourceMemberId | leadingZero : 8 }})</span
        >
        <span *ngIf="account.spousalRolloverSourceMemberName as sourceMemberName" class="account-holder" i18n
          >Continuation from {{ sourceMemberName }}</span
        >
      </ng-template>
      <div class="account-id">{{ account.id | leadingZero : 8 }}</div>
    </div>
    <div class="description-and-balance">
      <span class="title-md">{{ balance | currency }}</span>
      <span class="description-text" *ngIf="descriptionText" i18n>{{ descriptionText }}</span>
    </div>
  </div>
</div>
